import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustom0151Envelope({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17.579 4H2.42C1.638 4 1 4.673 1 5.5v9c0 .827.638 1.5 1.421 1.5H17.58c.783 0 1.421-.673 1.421-1.5v-9c0-.827-.638-1.5-1.421-1.5zm0 1c.028 0 .055.003.082.008l-7.135 5.021c-.275.193-.776.193-1.05 0L2.34 5.008A.444.444 0 012.422 5H17.58h-.001zm0 10H2.42a.488.488 0 01-.474-.5V5.934l7.002 4.927c.295.207.673.311 1.051.311.378 0 .756-.104 1.05-.311l7.003-4.927V14.5c0 .276-.213.5-.474.5z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
export default SvgIconCustom0151Envelope;
